import React, { useCallback } from 'react';
import * as types from '../Type';

export const processUsedColumnsForType = (field, value, setUsedColumns) => {
  const fieldType = types[field.component];

  if (!fieldType) return;

  setUsedColumns(obj => ({
    ...obj,
    [field.id]: !value ? undefined : fieldType.getConsumedColumns(value),
  }));
};

const MappingFieldWithType = ({
  field,
  value,
  setValue,
  fieldType,
  availableColumns,
  setUsedColumns,
}) => {
  const FieldTypeComponent = fieldType.Component;

  const onChange = useCallback(
    value => {
      const valueNormalized = !value
        ? undefined
        : {
            __typename: `CSVMappingFieldValue${field.component}`,
            ...value,
          };

      setValue(obj => ({
        ...obj,
        [field.id]: valueNormalized,
      }));

      processUsedColumnsForType(field, valueNormalized, setUsedColumns);
    },
    [setValue, field, setUsedColumns],
  );

  return (
    <FieldTypeComponent
      field={field}
      onChange={onChange}
      value={value}
      availableColumns={availableColumns}
    />
  );
};

const MappingField = props => {
  if (!props.field) {
    return <div>No field provided</div>;
  }

  const fieldType = types[props.field.component];

  if (!fieldType) {
    return (
      <tr>
        <td colSpan={4}>
          No field type found for {props.field.component} ({props.field.id})
        </td>
      </tr>
    );
  }

  return <MappingFieldWithType {...props} fieldType={fieldType} />;
};

export default MappingField;
